<template>
    <div>
        <vs-table stripe :data="payments"
            noDataText="">

            <template slot="thead">
                <vs-th>Tipo</vs-th>
                <!-- <vs-th class="xs:hidden md:table-cell">Desconto</vs-th>
                <vs-th class="xs:hidden md:table-cell">Taxa</vs-th> -->
                <vs-th>Hora</vs-th>
                <vs-th>Valor</vs-th>
            </template>

            <template slot-scope="{data}">
                <vs-tr :key="data[indextr].id" v-for="(tr, indextr) in data" >
                    <vs-td>
                        <PaymentFormIcon v-if="data[indextr].date"
                            :icon="paymentIcons[data[indextr].type].img"
                            :description="paymentIcons[data[indextr].type].description" />
                        
                        <vs-dropdown v-else vs-trigger-click class="xs:hide md:block  cursor-pointer" >
                            <div class="flex items-center">
                                <PaymentFormIcon
                                    :icon="paymentIcons[data[indextr].type].img"
                                    :description="paymentIcons[data[indextr].type].description" />
                                <vs-button
                                    size="small" type="flat"
                                    class="btn-drop"
                                    icon="expand_more" >
                                </vs-button>
                                <vs-dropdown-menu style="z-index: 999999">
                                    <p class="px-4 p-2">Alterar tipo de pagamento:</p>
                                    <vs-dropdown-item class="my-2" 
                                        v-for="paymentType in otherPaymentTypes(data[indextr])" :key="paymentType.key"
                                        @click="changeType(indextr, paymentType)"> 
                                        <img :src="paymentIcons[paymentType.key].img" width="35"/>
                                        {{ paymentType.description }}
                                    </vs-dropdown-item>
                                </vs-dropdown-menu>
                            </div>
                        </vs-dropdown>
                    </vs-td>
<!-- 
                    <vs-td :data="data[indextr].id" class="xs:hidden md:table-cell sm:text-base md:text-lg">
                        {{data[indextr].discount | currency }}
                    </vs-td>

                    <vs-td :data="data[indextr].id" class="xs:hidden md:table-cell sm:text-base md:text-lg">
                        {{data[indextr].taxesValue | currency }}
                    </vs-td> -->
                    
                    <vs-td v-if="data[indextr].date" :data="data[indextr].date" class="sm:text-base md:text-lg">
                        {{ data[indextr].date.toDate() | moment('HH:mm') }}
                    </vs-td>
    
                    <vs-td v-else :data="data[indextr].date" class="sm:text-base md:text-lg">
                        <div class="flex flex-col items-center justify-center" style="width: 80px">
                            <b><span class="text-base text-danger">Pendente</span></b>
                            <vs-button type="flat" class="p-0 hover:bg-danger hover:text-white" size="small"
                                @click="removeTempPayment(indextr)">
                                (Remover)
                            </vs-button>
                        </div>
                    </vs-td>

                    <vs-td :data="data[indextr].value" class="sm:text-base md:text-lg">
                        <b>{{data[indextr].value | currency }}</b>
                    </vs-td>

                </vs-tr>
            </template>
        </vs-table>
        <a-empty v-show="!payments.length" class="relative center">
            <span slot="description"> 
                <p class="xs:text-lg md:text-2xl font-bold opacity-50">Sem pagamentos registrados</p>
                <span class="xs:text-sm md:text-base opacity-75">Adicione valores no campo a direita. Aperte <b>Incluir</b> para confimar.</span><br/>
                <p class="xs:text-sm md:text-base mt-2 opacity-75">Assim que todo o valor da conta for coberto, a conta será <b>fechada</b>.</p>
            </span>
        </a-empty>
    </div>
</template>

<script>
import { mapActions, mapMutations, mapState, mapGetters } from 'vuex';
import PaymentFormIcon from './PaymentFormIcon';

    const paymentIcons = {
        money:          { description : 'Dinheiro', img: require('@/assets/images/payment/money_red.png') },
        card_credit:    { description : 'Crédito', img : require('@/assets/images/payment/card_red.png') },
        card_debit:     { description : 'Débito', img : require('@/assets/images/payment/card_red.png') },
        picpay:         { description : 'PicPay', img : require('@/assets/images/payment/qr-code.png') },
        pix:            { description : 'Pix', img : require('@/assets/images/payment/pix.png') },
        // unknow:         { description : 'Outro', img : '' },
    };

    export default {
        components: {PaymentFormIcon},
        props: {
            bill: Object,
        },
        data() {
            return {
                paymentIcons,
            };
        },
        computed: {
            ...mapState('payment', ['tempPayments']),
            ...mapGetters('payment', ['payments'])
        },
        methods: {
            otherPaymentTypes (payment) {
                return Object.entries(this.paymentIcons)
                    .filter(([key]) => key !== payment.type)
                    .map(([key, obj]) => ({ key, ...obj }));
            },
            changeType (index, payment) {
                this.changeTemPaymentType({ index, type: payment.key });
            },
            ...mapActions('payment', ['openPaymentSnapshot']),
            ...mapMutations('payment', ['disposeSnapshot', 'removeTempPayment', 'changeTemPaymentType'])
        },
        async beforeMount () {
            const { bill } = this;
            await this.openPaymentSnapshot({ billId: bill.id }); // does not block call since it will fetch a snapshot
        },
        async beforeDestroy () {
            // closes connection for payment updates
            this.disposeSnapshot();
        }
    }
</script>

<style lang="scss" scoped>
    .center {
        top: 50%;
    }
</style>